import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconKeyboard"><Path d="M18.75 5.5H5.25C3.59315 5.5 2.25 6.84315 2.25 8.5V15.5C2.25 17.1569 3.59315 18.5 5.25 18.5H18.75C20.4069 18.5 21.75 17.1569 21.75 15.5V8.5C21.75 6.84315 20.4069 5.5 18.75 5.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Path d="M6.25 10H6.61M6.25 14H6.61M9.96 10H10.32M13.68 10H14.04M17.39 10H17.75M17.39 14H17.75M9.96 14H14.04" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></CentralIconBase>;
});

export default IconKeyboard;
